import { apiClient } from './client';

export interface ConciergeRecipeEligibility {
  eligible: boolean;
  reason: string | null;
  hasFinalizedRecipe: boolean;
  returnCount: number;
}

export interface ConciergeRecipeDiffRow {
  key: string;
  section: string;
  label: string;
  current: string | null;
  proposed: string;
  applicable: boolean;
  reason: string | null;
  deferred: boolean;
}

export interface ConciergeRecipeContext {
  merchantVertical: string | null;
  // Added by a companion backend API that may not be deployed yet -- optional/nullable so this
  // type doesn't lie about a guarantee an older response can't meet. ConciergeRecipePage.vue
  // already defaults each one with `??`.
  monthlyReturns?: string | null;
  segment?: string | null;
  targetLaunchDate?: string | null;
  contactName: string | null;
  contactRole?: string | null;
  problem: string | null;
  briefingParagraphs?: string[] | null;
  finalizedAt: string | null;
}

export interface ConciergeRecipeDiffResponse {
  eligibility: ConciergeRecipeEligibility;
  rows: ConciergeRecipeDiffRow[];
  recipe: ConciergeRecipeContext | null;
}

export interface ConciergeRecipeApplyResult {
  key: string;
  applied: boolean;
  message: string | null;
}

export interface ConciergeRecipeApplyResponse {
  ok: boolean;
  results: ConciergeRecipeApplyResult[];
  failureReason: string | null;
}

export function getEligibility (shopId: number | string) {
  return apiClient.get<ConciergeRecipeEligibility>(`/${shopId}/concierge-recipe/eligibility`);
}

export function getDiff (shopId: number | string) {
  return apiClient.get<ConciergeRecipeDiffResponse>(`/${shopId}/concierge-recipe`);
}

export function apply (shopId: number | string, keys: string[]) {
  return apiClient.post<ConciergeRecipeApplyResponse>(`/${shopId}/concierge-recipe/apply`, { keys });
}
